import { PINGFLO_TOUR_ACTIVE_EVENT } from "./tourEvents";

/** Highlight the real control, never a demo overlay. Skip hidden keep-alive copies. */
export function queryTourTarget(tourId) {
  if (!tourId || typeof document === "undefined") return null;
  const escaped = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(tourId) : tourId;
  const nodes = document.querySelectorAll(`[data-tour-id="${escaped}"]`);
  for (const el of nodes) {
    const rect = el.getBoundingClientRect();
    if (rect.width > 0 || rect.height > 0) return el;
  }
  return nodes[0] || null;
}

export function isPingfloTourRunning() {
  return typeof document !== "undefined" && document.documentElement.getAttribute("data-pingflo-tour") === "1";
}

export function setPingfloTourRunning(active) {
  if (typeof document === "undefined") return;
  if (active) document.documentElement.setAttribute("data-pingflo-tour", "1");
  else document.documentElement.removeAttribute("data-pingflo-tour");
  try {
    window.dispatchEvent(
      new CustomEvent(PINGFLO_TOUR_ACTIVE_EVENT, { detail: { active: Boolean(active) } })
    );
  } catch {
    /* ignore */
  }
}
